import { schoolLogsControllerSearchSchools } from './schoolLogsControllerSearchSchools'

export const schoolLogsService = { schoolLogsControllerSearchSchools }